import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useRouter } from "next/router";
import classNames from "classnames";
import { hideModals } from "@app/store/layoutSlice";
import { useCreateFullReportMutation, useGetUserReportBalanceQuery } from "@entities/history";
import { RouterConfig } from "@shared/lib/routerConfig";
import { BalanceConfirmModalProps } from "./types";
import classes from "./balance-confirm-modal.module.scss";

export const BalanceConfirmModal = ({ onClose }: BalanceConfirmModalProps) => {
    const dispatch = useDispatch();
    const router = useRouter();
    const slug = router.query.slug as string;
    const [createFullReport] = useCreateFullReportMutation();
    const { data: balance = 0 } = useGetUserReportBalanceQuery();

    const handleConfirm = async () => {
        if (!slug) return;

        try {
            const report = await createFullReport({ code: slug }).unwrap();
            dispatch(hideModals());
            router.push(`${RouterConfig.HISTORY}/report/${report.id}`);
        } catch (error) {
            toast.error("Ошибка при создании отчета");
            dispatch(hideModals());
        }
    };

    return (
        <div className={classes["balance-modal"]}>
            <div className={classes["balance-modal__info"]}>
                Осталось {balance} проверок.
                <span className={classes["balance-modal__question"]}>Списать 1 шт?</span>
            </div>
            <div className={classes["balance-modal__actions"]}>
                <button className={classes["balance-modal__button"]} onClick={onClose}>
                    Нет
                </button>
                <button
                    className={classNames(
                        classes["balance-modal__button"],
                        classes["balance-modal__button--confirm"]
                    )}
                    onClick={handleConfirm}
                >
                    Да
                </button>
            </div>
        </div>
    );
};